import React, { useState } from "react";
import Stylecontact from "./contact.module.css";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import ContactImg from "../../Ui/contactImg.jpg";
import { motion } from "framer-motion";
import Cover from "../cover";
import ContactCover from "../../Ui/contactCover.jpg";
import ContactCover1 from "../../Ui/contactCover1.jpeg";
import ContactCover2 from "../../Ui/contactCover2.jpeg";
import { MdPhone, MdEmail, MdLocationOn } from "react-icons/md";

const Contact = () => {
  const [contactData, setContactData] = useState({
    name: "",
    email: "",
    subject: "",
    comments: "",
  });

  const InputHandler = (e) => {
    setContactData({ ...contactData, [e.target.name]: e.target.value });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    alert("Message submitted successfully!");
    setContactData({
      name: "",
      email: "",
      subject: "",
      comments: "",
    });
  };

  return (
    <>
      <Cover
        images={[ContactCover, ContactCover1, ContactCover2]}
        heading="Contact Us"
        subHeading="We are here to help you. Feel free to reach out to us with any questions or concerns."
      />

      <div className={Stylecontact.maincontainer}>
        <div className={Stylecontact.infocards}>
          <motion.div
            className={Stylecontact.infobox}
            initial={{ opacity: 0, scale: 0.8, y: 50 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            whileHover={{ scale: 1.05 }}
            transition={{
              duration: 0.8,
              ease: "easeOut",
              type: "spring",
              delay: 1 * 0.3,
            }}
          >
            <MdPhone size={40} color="#1976d2" />
            <h3>Phone</h3>
            <p>+92 300 1234567</p>
          </motion.div>

          <motion.div
            className={Stylecontact.infobox}
            initial={{ opacity: 0, scale: 0.8, y: 50 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            whileHover={{ scale: 1.05 }}
            transition={{
              duration: 0.8,
              ease: "easeOut",
              type: "spring",
              delay: 2 * 0.3,
            }}
          >
            <MdEmail size={40} color="#1976d2" />
            <h3>Email</h3>
            <p>contact@yourdomain.com</p>
          </motion.div>

          <motion.div
            className={Stylecontact.infobox}
            initial={{ opacity: 0, scale: 0.8, y: 50 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            whileHover={{ scale: 1.05 }}
            transition={{
              duration: 0.8,
              ease: "easeOut",
              type: "spring",
              delay: 3 * 0.3,
            }}
          >
            <MdLocationOn size={40} color="#1976d2" />
            <h3>Address</h3>
            <p>123 Health Street, Karachi, Pakistan</p>
          </motion.div>
        </div>

        <div className={Stylecontact.contactcontainer}>
          <motion.h2
            initial={{ opacity: 0, y: -100 }}
            whileInView={{ opacity: 1, y: [50, 0] }}
            transition={{ duration: 1 }}
            className={Stylecontact.heading}
          >
            Get In Touch
          </motion.h2>

          <div className={Stylecontact.formbox}>
            <form className={Stylecontact.form} onSubmit={submitHandler}>
              <div className={Stylecontact.inputrow}>
                <TextField
                  label="Your Name"
                  variant="outlined"
                  name="name"
                  type="text"
                  value={contactData.name}
                  onChange={InputHandler}
                  className={Stylecontact.textfield}
                />
                <TextField
                  label="Your Email"
                  variant="outlined"
                  name="email"
                  type="email"
                  value={contactData.email}
                  onChange={InputHandler}
                  className={Stylecontact.textfield}
                />
              </div>

              <TextField
                label="Subject"
                variant="outlined"
                name="subject"
                type="text"
                value={contactData.subject}
                onChange={InputHandler}
                className={Stylecontact.fullwidth}
              />

              <TextField
                label="Comments"
                variant="outlined"
                name="comments"
                type="text"
                value={contactData.comments}
                onChange={InputHandler}
                multiline
                minRows={4}
                className={Stylecontact.fullwidth}
              />

              <Button
                variant="contained"
                type="submit"
                className={Stylecontact.submitbtn}
              >
                Submit
              </Button>
            </form>
          </div>

          <motion.h4
            className={Stylecontact.mapheading}
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: [50, 0] }}
          >
            Find Us On
          </motion.h4>
          <div className={Stylecontact.mapwrapper}>
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d463175.15591636114!2d66.83539192527361!3d24.91312543728018!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb339fc7861e19b%3A0xc3039a8a08d19bfd!2sKarachi%20urban%20nafsiati%20hospital!5e0!3m2!1sen!2s!4v1708444852707!5m2!1sen!2s"
              width="100%"
              height="400"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
